import { render, staticRenderFns } from "./dargList.vue?vue&type=template&id=b353f1e0"
import script from "./dargList.vue?vue&type=script&lang=js"
export * from "./dargList.vue?vue&type=script&lang=js"
import style0 from "./dargList.vue?vue&type=style&index=0&id=b353f1e0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b353f1e0')) {
      api.createRecord('b353f1e0', component.options)
    } else {
      api.reload('b353f1e0', component.options)
    }
    module.hot.accept("./dargList.vue?vue&type=template&id=b353f1e0", function () {
      api.rerender('b353f1e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/marketplane/components/dargList.vue"
export default component.exports